import { css } from '@emotion/react';
import { type FC } from 'react';
import { LinkComponent } from '~/_shared/baseComponents/links';
import {
  MAPTIVE_PRIVACY_POLICY, MAPTIVE_TERMS_OF_SERVICE,
} from '~/_shared/constants/maptive';
import {
  s, Trans,
} from '~/translations/Trans';

const linkStyle = css({
  fontSize: 'inherit',
});

type TermsAndPrivacyNoticeProps = {
  className?: string;
};

export const TermsAndPrivacyNoticeComponent: FC<TermsAndPrivacyNoticeProps> = (props) => {
  return (
    <div className={props.className}>
      <Trans i18nKey="signup.agreement">
        {s('prefix')}
        <LinkComponent
          css={linkStyle}
          path={MAPTIVE_TERMS_OF_SERVICE}
          target="_blank"
        >
          {s('termsOfService')}
        </LinkComponent>
        {s('separator')}
        <LinkComponent
          css={linkStyle}
          path={MAPTIVE_PRIVACY_POLICY}
          target="_blank"
        >
          {s('privacyPolicy')}
        </LinkComponent>
        {s('suffix')}
      </Trans>
    </div>
  );
};
